export const labelSty = {
  fontFamily: "Poppins",
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "23px",
  letterSpacing: "-0.23999999463558197px",
  textAlign: "left",
  color: "#000",
  marginBottom: 1,
};

export const styInput = {
  paddingLeft: "8px",
  fontSize: "13px",
  fontFamily: "Poppins",
  fontWeight: 400,
  borderRadius: "10px",
  color: "#000",
};

export const textareaSty = {
  padding: "12px",
  fontSize: "13px",
  fontFamily: "Poppins",
  fontWeight: 400,
  borderRadius: "6px",
  border: "none",
  backgroundColor: "#F5F7F9",
  color: "#000",
  outline: "none",
};

export const labelStyles = {
  fontFamily: "Poppins",
  fontSize: "12px",
  fontWeight: 500,
  lineHeight: "18px",
  letterSpacing: "-0.23999999463558197px",
  textAlign: "left",
  color: "#7991A4",
  marginBottom: 1,
};

export const textSty = {
  fontSize: "13px",
  fontWeight: 400,
  color: "#0A0B0A",
  lineHeight: "21px",
};